import { createReducer, on } from '@ngrx/store';
import { LicenseConfiguration } from '../license-configuration';
import {
  licenseConfigurationGetSuccess,
  licenseGetNameSuccess,
  licenseLoadExtensionsSuccess,
} from './license-configuration.actions';

export const initialState: LicenseConfiguration = {
  product: 'irp',
  candidateExternalUrl: null,
  jobExternalUrl: null,
  licenseName: null,
  licenseExtensions: [],
} as LicenseConfiguration;

export const licenseConfigurationReducer = createReducer(
  initialState,
  on(licenseConfigurationGetSuccess, (state, { payload }) => {
    const config = { ...payload };
    return {
      ...state,
      candidateExternalUrl: config.candidateExternalUrl,
      jobExternalUrl: config.jobExternalUrl,
    };
  }),
  on(licenseGetNameSuccess, (state, { payload }) => ({
    ...state,
    licenseName: payload,
  })),
  on(licenseLoadExtensionsSuccess, (state, { licenseExtensions }) => ({
    ...state,
    licenseExtensions,
  })),
);
